import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=8c1c4b6e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c1c4b6e')) {
      api.createRecord('8c1c4b6e', component.options)
    } else {
      api.reload('8c1c4b6e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=8c1c4b6e&", function () {
      api.rerender('8c1c4b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V0jqQNr6L1JH/JS/imageCarousel.vue"
export default component.exports